import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { CTAButton } from './CTAButton';
export function FinalSection() {
  return <section className="relative isolate overflow-hidden border-t border-white/5 bg-void-900 py-28 md:py-36" data-id="element-70" data-mp="3c0rejdzm62rv">
      <div className="neon-grid pointer-events-none absolute inset-0 opacity-50" aria-hidden="true" data-id="element-71" data-mp="332feymgrruna" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-64 bg-gold-500/[0.12] blur-3xl" aria-hidden="true" data-id="element-72" data-mp="2odt2csij1gzr" />
      <div className="relative mx-auto max-w-3xl px-6" data-id="element-73" data-mp="2t5191gsh2o98">
        <Reveal data-id="element-74" data-mp="2fd4obxt4vgmv">
          <SectionLabel data-id="element-75" data-mp="2fdnvcjh8wkm4">Última invitación</SectionLabel>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-76" data-mp="2fb1mmgimbz2b">
            Hay puertas que solo se abren cuando decides cruzarlas.
          </h2>
        </Reveal>

        <div className="mt-9 space-y-6 text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-77" data-mp="2ads0b9qj03ip">
          <Reveal delay={0.06} data-id="element-78" data-mp="2afmf06b7ezec">
            <p data-id="element-79" data-mp="2wdbu4xuw0wmi">
              Llegaste hasta el final de esta página por una razón. Quizás todavía dudas. Quizás
              algo te dice que esto es para ti. Las señales no son casuales: son recordatorios.
            </p>
          </Reveal>
          <Reveal delay={0.12} data-id="element-80" data-mp="35e05tlwt6kw8">
            <p data-id="element-81" data-mp="30fydeadht983">
              Este eBook no te va a salvar. Tú vas a hacerlo. Solo es una guía, una conversación
              íntima entre tú y eso que siempre has sabido.
            </p>
          </Reveal>
          <Reveal delay={0.18} data-id="element-82" data-mp="28oshy78pvzp5">
            <p className="font-display text-2xl italic leading-snug text-bone-100 sm:text-3xl" data-id="element-83" data-mp="28ptw4kl152b3">
              La pregunta ya no es si la realidad es lo que parece. La pregunta es cuánto tiempo
              más vas a esperar para verlo por ti mismo.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.24} data-id="element-84" data-mp="1tybl71711xyl">
          <CTAButton label="Obtener acceso inmediato" className="mt-11" data-id="element-85" data-mp="1txjofn1p1u6q" />
          <p className="mt-5 text-xs text-bone-500" data-id="element-86" data-mp="1ozru6mdktvzd">
            $9.990 CLP · Descarga al instante por Hotmart
          </p>
        </Reveal>

        <Reveal delay={0.3} data-id="element-87" data-mp="3u1vyknjhx684">
          <p className="neon-text mt-16 border-t border-gold-500/15 pt-12 text-center font-display text-2xl font-light text-gold-400 sm:text-3xl" data-id="element-88" data-mp="3u142zcpwf8hu">
            Despertar no es un destino. Es una decisión.
          </p>
          <p className="mt-3 text-center font-display text-2xl italic text-bone-100 sm:text-3xl" data-id="element-89" data-mp="7kztnpap68cz">
            ¿Estás listo para jugar?
          </p>
        </Reveal>
      </div>
    </section>;
}